/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingconnecthinttitle3Inputs */

const en_crosspostingconnecthinttitle3 = /** @type {(inputs: Crosspostingconnecthinttitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before you connect`)
};

const de_crosspostingconnecthinttitle3 = /** @type {(inputs: Crosspostingconnecthinttitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevor du verbindest`)
};

/**
* | output |
* | --- |
* | "Before you connect" |
*
* @param {Crosspostingconnecthinttitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingconnecthinttitle3 = /** @type {((inputs?: Crosspostingconnecthinttitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingconnecthinttitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingconnecthinttitle3(inputs)
	return de_crosspostingconnecthinttitle3(inputs)
});
export { crosspostingconnecthinttitle3 as "crosspostingConnectHintTitle" }